var module = angular.module('octopusApp.infrastructure');

module.directive('focusMe', function ($timeout) {
  return {
    restrict: 'AC',
    link: function (scope, element, attr) {
      var focus = scope.$eval(attr.focusMe);

      if (focus === false) {
        return;
      }

      setTimeout(function(){ element[0].focus(); },500);
    }
  };
});

module.directive('focusOn', function($timeout) {
  return function(scope, element, attr) {
    scope.$on('focusOn', function(e, name) {
      if(name === attr.focusOn) {
        $timeout(function () {
          element[0].focus();
        });
      }
    });
  };
});

module.factory('focus', function ($rootScope, $timeout) {
  return function(name) {
    $timeout(function (){
      $rootScope.$broadcast('focusOn', name);
    });
  };
});



//////////////////
// WEBPACK FOOTER
// ./app/infrastructure/directives/focus_me.js
// module id = 5005706610119729
// module chunks = 1